import React from "react";
import WebProfitSpinner from "../system/WebProfitSpinner";
import { Box, Stack, Typography } from "@mui/material";

const BRAND = {
  orange: "#F35A3A",
  dark: "var(--wp-panel-text-primary, #19242F)",
  muted: "rgba(var(--wp-panel-ink-rgb, 25,36,47),.58)",
  background: "var(--wp-panel-bg, #F6F7FB)",
};

/**
 * Estado de carga visual compartido por las secciones del panel.
 *
 * Regla: usarlo cuando una sección todavía no tiene contenido real para mostrar.
 * Para refrescos sobre contenido ya visible conviene conservar el feedback local
 * (progreso real o el loader compacto de marca dentro de la acción) para no hacer saltar la UI.
 */
export default function DashboardLoadingState({
  label = "Cargando información…",
  helper = "",
  minHeight = 320,
  fullPage = false,
}) {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
      sx={{
        width: "100%",
        minHeight: fullPage ? "100vh" : minHeight,
        display: "grid",
        placeItems: "center",
        px: 2,
        py: fullPage ? 4 : 3,
        bgcolor: fullPage ? BRAND.background : "transparent",
      }}
    >
      <Stack spacing={1.35} alignItems="center" textAlign="center" sx={{ maxWidth: 520 }}>
        <WebProfitSpinner size={42} decorative />
        <Typography sx={{ color: BRAND.dark, fontWeight: 900, lineHeight: 1.25 }}>
          {label}
        </Typography>
        {helper ? (
          <Typography variant="body2" sx={{ color: BRAND.muted, lineHeight: 1.45 }}>
            {helper}
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
}
